import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import type {
    GetVerifiedEmailAddresses as GetVerifiedEmailAddressesQuery,
    GetVerifiedEmailAddresses_fromAddresses_edges_node as EmailAddress,
    GetVerifiedEmailAddressesVariables,
} from 'nutshell-graphql-types';

import {VerifySenderAddressModal} from '../email-marketing/verify-sender-address-modal/verify-sender-address-modal';

import {GraphQLSelect} from './graphql-select';
import GET_ADDRESSES from './queries/get-verified-email-addresses.graphql';

type Props = {
    userId?: string;
    selectedId: string | null | undefined;
    autoFocus?: boolean;
    onlyIncludeVerified?: boolean;
    onChange: (newValue: any) => any;
    onNumberOfEmailAddressesChange?: (numberOfEmailAddresses: number) => void;
    onIsLoadingChange?: (isLoading: boolean) => void;
};

export const GraphQLSelectMarketingEmails = (props: Props) => {
    const [isAddingNewAddress, setIsAddingNewAddress] = React.useState<boolean>(false);

    const variables = props.userId ? {userId: props.userId} : {};
    const {data, loading} = useQuery<
        GetVerifiedEmailAddressesQuery,
        GetVerifiedEmailAddressesVariables
    >(GET_ADDRESSES, {
        variables,
        fetchPolicy: 'cache-and-network',
    });
    const fromAddresses = data ? data.fromAddresses : null;

    let emailAddresses = fromAddresses
        ? fromAddresses.edges.map((fromAddress) => {
              return {
                  ...fromAddress.node,
                  display: fromAddress.node.emailAddress.formatted,
              };
          })
        : [];

    if (props.onlyIncludeVerified) {
        emailAddresses = emailAddresses.filter((address) => address.status === 'VERIFIED');
    }

    React.useEffect(() => {
        if (props.onIsLoadingChange) {
            props.onIsLoadingChange(loading);
        }

        if (props.onNumberOfEmailAddressesChange) {
            props.onNumberOfEmailAddressesChange(emailAddresses.length);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, emailAddresses]);

    return (
        <>
            <GraphQLSelect
                {...props}
                onChange={props.onChange}
                isLoading={loading}
                // @ts-expect-error
                openMenuOnFocus={true}
                placeholder='Search sender addresses…'
                models={emailAddresses}
                labelKey='display'
                footerButton={
                    !props.onlyIncludeVerified
                        ? {
                              label: 'Verify new email address',
                              onClick: () => setIsAddingNewAddress(true),
                          }
                        : undefined
                }
            />
            {isAddingNewAddress ? (
                <VerifySenderAddressModal
                    userId={props.userId}
                    onSendVerificationEmail={(emailAddress: EmailAddress) => {
                        props.onChange(emailAddress);
                    }}
                    onClose={() => setIsAddingNewAddress(false)}
                />
            ) : undefined}
        </>
    );
};
